import { TaskClockModel } from "./TaskClockModel";

// services
import Api from "@/services/Api";

interface TimeDiff 
{
    seconds?: number;
    hhmmss?: string;
}

class ClockHelper
{

    public toHHMMSS (secs:number):string
    {
        let neg = (secs < 0);

        secs = Math.abs(secs);
        let sec_num = parseInt(secs + "", 10);
        let hours = Math.floor(sec_num / 3600);
        let minutes = Math.floor(sec_num / 60) % 60;
        let seconds = sec_num % 60;

        let time = [hours, minutes, seconds]
            .map(v => v < 10 ? "0" + v : v)
            .filter((v, i) => v !== "00" || i > 0)
            .join(":");

        if (neg) 
        {
            time = "-" + time;
        }

        return time;
    }

    public calcFee (secondsWorked:number, ratePerHour:number):string
    {
        if (!ratePerHour)
        {
            return (0).toFixed(2);
        }

        let hours = Number(secondsWorked / 3600).toFixed(2);
        return (Number(hours) * ratePerHour).toFixed(2);
    }

    public calcDiff (date1:Date | string, date2:Date | string, subtract?:number):TimeDiff
    {
        // alert(date1);
        // alert(date2);

        // convert any string dates tp Date
        if (typeof date1 === "string")
        {
            date1 = new Date(date1 + "Z");
        }

        if (typeof date2 === "string")
        {
            date2 = new Date(date2 + "Z");
        }

        let seconds = (
            date1.getTime() - date2.getTime()
        ) / 1000;
    
        if (subtract) 
        {
            seconds = seconds - subtract;
        }
    
        seconds = Math.ceil(seconds);
    
        return {
            seconds: seconds,
            hhmmss: this.toHHMMSS(seconds),
        };
    }

    public calcPaused (clock:TaskClockModel):TimeDiff
    {
        let sec:number = 0;
        
        if (clock.Paused)
        {
            let now = new Date();
            let pau = new Date(clock.Paused /* + "Z" */);
            let dif = this.calcDiff(now, pau);
            sec += Number(dif.seconds);
        }

        if (clock.PausedList?.length)
        {
            // console.debug("sec", sec);
            
            clock.PausedList.forEach((row) =>
            {
                sec += Number(row.Diff);
            });
        }
    
        return {
            seconds: sec,
            hhmmss: this.toHHMMSS(sec)
        };
    }
}


export default ClockHelper;